import React from 'react';
import { useAuth } from '../../auth/AuthProvider';
import Header from '../../components/Header';
import { styles, colors, radius, shadows } from '../../styles/theme';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const YedeklemePage = () => {
  const { user } = useAuth();

  const userId = user?.id || 1;

  const handleBackup = () => {
    window.open(`${API_URL}/api/backup/export?user_id=${userId}`, '_blank');
  };

  return (
    <div>
      <Header title="💾 Yedekleme İşlemleri" />

      <div
        style={{
          padding: '20px',
          background: colors.background,
          minHeight: 'calc(100vh - 60px)',
        }}
      >
        <div style={{ maxWidth: '700px' }}>
          {/* Yedek Al */}
          <div
            style={{
              background: colors.surface,
              padding: '30px',
              borderRadius: radius.md,
              boxShadow: shadows.sm,
            }}
          >
            <h3 style={{ color: styles.primary, marginTop: 0 }}>
              📤 Yedek Al (Export)
            </h3>

            <p>
              Mevcut veritabanının bir kopyasını bilgisayarınıza indirin.
              Otomatik olarak tarihli dosya oluşturulur.
            </p>

            <button
              onClick={handleBackup}
              style={{
                padding: '15px 30px',
                background: styles.primary,
                color: 'white',
                border: 'none',
                borderRadius: radius.sm,
                fontSize: '16px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              ⬇️ VERİTABANINI İNDİR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YedeklemePage;
